import { Accordion, AccordionDetails, AccordionSummary, styled } from '@mui/material';

export const HBAccordionRootStyle = styled(Accordion)(() => ``);

export const HBAccordionSummary = styled(AccordionSummary)(() => ``) as typeof AccordionSummary;

export const HBAccordionDetails = styled(AccordionDetails)(() => ``);
